// Cabin Crew Training - Tüm İçerikleri Birleştiren Ana Dosya

import { LESSON_CONTENTS } from './lessonContents';
import { CABIN_CREW_CONTENTS } from './lessonContentsCabinCrew';
import { INTERVIEW_CONTENTS } from './lessonContentsInterview';
import { dragDropQuestions } from './dragDropQuestions';

// Tüm içerikleri birleştir
export const ALL_LESSON_CONTENTS = {
  ...LESSON_CONTENTS,
  ...CABIN_CREW_CONTENTS,
  ...INTERVIEW_CONTENTS,
  ...dragDropQuestions
};

// İçerik getirme fonksiyonu
export const getLessonContent = (unitId, lessonId) => {
  const key = `${unitId}-${lessonId}`;
  return ALL_LESSON_CONTENTS[key] || null;
};

// Ünite içerik kontrolü
export const hasLessonContent = (unitId, lessonId) => {
  const key = `${unitId}-${lessonId}`;
  return !!ALL_LESSON_CONTENTS[key];
};

// İçerik türüne göre getir
export const getLessonsByType = (type) => {
  return Object.entries(ALL_LESSON_CONTENTS)
    .filter(([key, content]) => content.type === type)
    .map(([key, content]) => ({ key, ...content }));
};

// Ünite içeriklerini getir
export const getUnitContents = (unitId) => {
  return Object.entries(ALL_LESSON_CONTENTS)
    .filter(([key]) => key.startsWith(`${unitId}-`))
    .reduce((acc, [key, content]) => {
      acc[key] = content;
      return acc;
    }, {});
};

export default ALL_LESSON_CONTENTS;
